import { Link } from "react-router-dom";
import ArticleCard from "@/components/base/ArticleCard";
import { formatCount, getHotArticles, type Article } from "@/utils/content";

type TocItem = {
  id: string;
  text: string;
};

type ArticleSidebarProps = {
  toc: TocItem[];
  related: Article[];
};

export default function ArticleSidebar({ toc, related }: ArticleSidebarProps) {
  const hot = getHotArticles(4);

  return (
    <aside className="flex w-full flex-col gap-6 lg:w-80">
      {toc.length > 0 && (
        <nav aria-label="内容目录" className="rounded-lg border border-background-200 bg-background-50 p-5">
          <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">内容目录</h2>
          <ol className="mt-4 flex flex-col gap-1">
            {toc.map((item, index) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  className="flex items-start gap-2 rounded-md px-2 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  <span className="text-xs font-semibold text-foreground-400">0{index + 1}</span>
                  {item.text}
                </a>
              </li>
            ))}
          </ol>
        </nav>
      )}

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">
          <i className="ri-fire-line text-primary-500" />
          热传榜
        </h2>
        <ol className="mt-4 flex flex-col gap-1">
          {hot.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/article/${item.id}`}
                className="group flex items-start gap-2.5 rounded-md p-1.5 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0">
                  <span className="line-clamp-2 block text-xs font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </span>
                  <span className="mt-0.5 block text-xs text-foreground-500">{formatCount(item.views)} 阅读</span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">相关推荐</h2>
        <div className="mt-4 flex flex-col gap-4">
          {related.map((item) => (
            <ArticleCard key={item.id} article={item} variant="row" />
          ))}
        </div>
      </div>
    </aside>
  );
}